import { AnimateOnScroll } from "../../../components/animate";
import { AnimateWordsOnScroll } from "../../../components/animate/animateWords";
import { Icon } from "../../../components/icon/icon";
import { whyChooseTikketFeatures } from "../data/landingContent";

export const WhyChooseTikketSection = () => {
  return (
    <section className="max-width-website relative overflow-hidden border-b border-grey-200 pb-[80px] pt-[50px] lg:pb-[100px]">
      <div className="relative z-10 grid grid-cols-1 items-start gap-10 lg:grid-cols-[minmax(0,0.92fr)_minmax(0,1fr)] lg:gap-x-16">
        <div className="relative z-10 order-1 flex flex-col lg:order-none">
          <div className="order-2 flex flex-col gap-[18px] lg:order-1">
            <AnimateWordsOnScroll
              as="h2"
              className="font-dela text-[32px] leading-[36px] tracking-[-0.64px] text-ink lg:text-[40px] lg:leading-[42px] lg:tracking-[-0.8px]"
            >
              Why event creators
              <br />
              choose Tikket
            </AnimateWordsOnScroll>
            <AnimateOnScroll animation="blur-up" delay={0.4}>
              <p className="font-onest text-[18px] leading-[26px] tracking-[-0.36px] text-grey-800 lg:text-[20px] lg:leading-[28px] lg:tracking-[-0.4px]">
                Whether you&apos;re hosting 20 guests or 2,000 attendees, Tikket
                grows alongside your events.
              </p>
            </AnimateOnScroll>
          </div>

          <div
            className="pointer-events-none relative z-0 order-1 mx-0 mb-9 aspect-[600/471] w-full max-w-[320px] overflow-visible sm:max-w-[380px] lg:order-2 lg:mx-0 lg:mb-0 lg:mt-14 lg:max-w-[410px]"
            aria-hidden
          >
            <img
              src="/assets/images/landing-why-calendar.png"
              alt=""
              className="absolute left-[2%] top-[4%] w-[54%] rotate-[17.44deg]"
            />
            <img
              src="/assets/images/landing-why-party-popper.png"
              alt=""
              className="absolute bottom-[4%] right-[4%] w-[57%] -rotate-[3.59deg]"
            />
          </div>
        </div>

        <div className="order-2 flex flex-col divide-y divide-grey-200 lg:order-none">
          {whyChooseTikketFeatures.map((feature, idx) => (
            <AnimateOnScroll
              key={feature.title}
              animation="fade-up"
              delay={0.15 + idx * 0.05}
              className="flex flex-col gap-6 py-8 first:pt-3 lg:flex-row lg:items-start"
            >
              <Icon
                svg={feature.icon}
                width={24}
                height={24}
                className="shrink-0 text-ink"
              />
              <div className="flex flex-col gap-2.5">
                <p className="font-onest text-xl font-semibold leading-6 tracking-[-0.4px] text-ink">
                  {feature.title}
                </p>
                <p className="font-onest text-[18px] leading-[26px] tracking-[-0.36px] text-grey-800 lg:leading-[28px]">
                  {feature.copy}
                </p>
              </div>
            </AnimateOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
};
